export const useInitMessaging = () => {
  return;
};
